export default function SpinnerLoader() {
  return (
    <div className="max-w-full h-[150px] mx-auto flex justify-center items-center">
      <div className="border-t-transparent border-solid animate-spin rounded-full border-clay border-8 h-14 w-14"></div>
    </div>
  );
}
